import {isDevEnvironment} from './isDevEnvironment';
import {getDevLogger} from './getLogger';

const devLogger = getDevLogger();

export type ServiceEnvironment =
  | 'devbox'
  | 'tunnel'
  | 'turbo'
  | 'qa'
  | 'preprod'
  | 'prod';

export const calculateDevboxPrefix = (): string => {
  const devboxPrefix = process.env.DEVBOX_QUALIFIER || process.env.QUALIFIER;
  if (devboxPrefix) {
    // Regular devboxes have a qualifier now
    // trailhead.corp.stripe.com/docs/devbox/working-with-services/new-all-devboxes-must-have-a-unique-qualifier
    const prefix = `${process.env.USER}-${devboxPrefix}-`;
    // jorgea-0-g6v1--manage-mydev.dev.stripe.me
    return prefix;
  } else {
    // Some older devboxes don't, so we still support this
    return `${process.env.USER}-`;
  }
};

export const getTunnelHost = (service: string): string =>
  `${process.env.USER}-${service}.tunnel.stripe.me`;

export const getDevboxHost = (service: string): string =>
  `${calculateDevboxPrefix()}-${service}-mydev.dev.stripe.me`;

// Return a PRR URL for services exposed via the edge stack (clusterfe/ingress)
export const getTurboHost = (service: string): string =>
  `${calculateDevboxPrefix()}-${service}-dev.dev.stripe.me`;

export const getTargetEnvironment = (
  targetEnvironment: ServiceEnvironment,
  environmentOverride: string | undefined = process.env.SERVICE_ENVIRONMENT,
  isDevelopmentBuild: boolean = isDevEnvironment,
): ServiceEnvironment => {
  // We only support changing target environment in devbox
  if (
    !isDevelopmentBuild ||
    targetEnvironment !== 'devbox' ||
    !environmentOverride
  ) {
    return targetEnvironment;
  }

  const lowercaseOverride = environmentOverride.toLowerCase();
  switch (lowercaseOverride) {
    case 'tunnel':
    case 'devbox':
    case 'qa':
    case 'preprod':
    case 'prod':
    case 'turbo':
      return lowercaseOverride;
    default:
      // Unexpected value encountered
      devLogger.error(
        'Devbox only target override is not a recognized value',
        environmentOverride,
      );
      return targetEnvironment;
  }
};
